import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import { contentPreviewMessages } from '../../messages';
import * as Styled from './styled';
import MessagesIntlProvider from '../MessagesIntlProvider';
export var DeleteUserContentPreviewScreen = /*#__PURE__*/function (_React$Component) {
  _inherits(DeleteUserContentPreviewScreen, _React$Component);
  var _super = _createSuper(DeleteUserContentPreviewScreen);
  function DeleteUserContentPreviewScreen() {
    var _this;
    _classCallCheck(this, DeleteUserContentPreviewScreen);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentActive: -1
    });
    _defineProperty(_assertThisInitialized(_this), "handleClickSection", function (userName, position) {
      return function () {
        _this.props.preferenceSelection(userName);
        _this.setState({
          currentActive: position
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "isCardSelected", function (position) {
      return position === _this.state.currentActive;
    });
    _defineProperty(_assertThisInitialized(_this), "selectAdminOrSelfCopy", function (adminCopy, selfCopy) {
      return _this.props.isCurrentUser ? selfCopy : adminCopy;
    });
    return _this;
  }
  _createClass(DeleteUserContentPreviewScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.preferenceSelection('');
    }
  }, {
    key: "render",
    value: function render() {
      var user = this.props.user;
      return /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(Styled.Screen, null, /*#__PURE__*/React.createElement(Styled.Title, null, /*#__PURE__*/React.createElement(FormattedMessage, this.selectAdminOrSelfCopy(contentPreviewMessages.headingAdmin, contentPreviewMessages.headingSelf))), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, this.selectAdminOrSelfCopy(contentPreviewMessages.paragraphSurveyAdmin, contentPreviewMessages.paragraphSurveySelf), {
        tagName: "p"
      })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, this.selectAdminOrSelfCopy(contentPreviewMessages.lineSurveyAdmin, contentPreviewMessages.lineSurveySelf), {
        tagName: "p"
      })), /*#__PURE__*/React.createElement(Styled.SectionCard, {
        className: "nameSectionCard",
        onClick: this.handleClickSection('Name', 1),
        isSelected: 1 === this.state.currentActive
      }, /*#__PURE__*/React.createElement(Styled.Avatar, null, /*#__PURE__*/React.createElement(Avatar, {
        size: "large",
        src: ""
      })), /*#__PURE__*/React.createElement(Styled.UserDetails, null, user.fullName)), /*#__PURE__*/React.createElement(Styled.SectionCard, {
        className: "formerUserSectionCard",
        onClick: this.handleClickSection('Former User', 0),
        isSelected: 0 === this.state.currentActive
      }, /*#__PURE__*/React.createElement(Styled.Avatar, null, /*#__PURE__*/React.createElement(Avatar, {
        size: "large",
        src: ""
      })), /*#__PURE__*/React.createElement(Styled.UserDetails, null, /*#__PURE__*/React.createElement(FormattedMessage, contentPreviewMessages.formerUser))), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, this.selectAdminOrSelfCopy(contentPreviewMessages.footnoteAdmin, contentPreviewMessages.footnoteSelf), {
        tagName: "p"
      }))));
    }
  }]);
  return DeleteUserContentPreviewScreen;
}(React.Component);
export default DeleteUserContentPreviewScreen;